import { Fragment, type ReactNode } from "react";

export const SettingsContentLayout = ({
  header,
  items,
}: {
  header: ReactNode;
  items: ReactNode[];
}) => (
  <div className="flex-col flex-fill px-800 py-400 gap-400">
    <div className="h-1000 flex-row items-center">{header}</div>
    {items.map((item, index) => (
      <Fragment key={index}>
        <div className="h-025 border-t border-primary-rest w-full" />
        {item}
      </Fragment>
    ))}
  </div>
);
